var f = Object.defineProperty, i = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var t = (o, e, r) => e in o ? f(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    p.call(e, r) && t(o, r, e[r]);
  if (a)
    for (var r of a(e))
      s.call(e, r) && t(o, r, e[r]);
  return o;
}, l = (o, e) => i(o, n(e));
import c, { forwardRef as d } from "react";
import w from "../lib/IconBase.mjs";
import I from "../defs/SolarPanel.mjs";
const P = d((o, e) => /* @__PURE__ */ c.createElement(w, l(m({ ref: e }, o), { weights: I })));
P.displayName = "SolarPanel";
export {
  P as SolarPanel
};
